module.exports = __webpack_public_path__ + "img/lupa.c8904e46.png";